import { Box, ListItem, Text, UnorderedList } from '@chakra-ui/react';

import { useTempInfo } from '../../../hooks/useTempInfo';

const OtherPayoff = () => {
  const { info } = useTempInfo();

  return (
    <Box w="95%" h="auto" textAlign="left">
      <Text fontWeight="bold" fontSize={{ md: '18px' }}>
        You'll need to contact {info?.data?.other_lienholder || 'your lease finance company'} to
        find your payoff amount and good-through date.
      </Text>
      <UnorderedList fontSize={{ md: '16px' }} mt={4}>
        <ListItem>You could give them a call or visit them at their website.</ListItem>
      </UnorderedList>
    </Box>
  );
};

export default OtherPayoff;
